<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <b-button
        variant="primary"
        @click="documentOrderModal()"        
        >
        {{ $t("CREATE") }}          
        </b-button>
      </template>
    </header-slot>

    <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        exact
        exact-active-class="active"
        :link-classes="['px-3', bgTabsNavs]"
        >{{ $t(item.title) }}
      </b-nav-item>
    </b-nav>

    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <router-view ref="routerViewTab" :key="routeName" />
    </b-card>
    <document-order-modal
    v-if="showModal"
    @hideModal="showModal = false"
    />
  </div>
</template>

<script>
import DocumentOrderModal from "@/views/operations/views/document-orders/modals/DocumentOrderModal.vue";
export default {
  name: "DocumentOrders",
  components: {
    DocumentOrderModal
  },
  directives: {},
  data() {
    return {
      showModal: false
    };
  },
  created() {},
  computed: {
    tabs() {
      return this.$route.matched[1].meta.tabs;
    },
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    documentOrderModal(){
      this.showModal = true
    }
  },
};
</script>

<style>
</style>